import { Link } from "react-router-dom";
import { Footer } from "@/pages/LandingPage";
import Logo from "@/components/Logo";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, subtitle, children, testId }) {
  return (
    <div className="bg-af min-h-screen">
      <header className="border-b border-af bg-af-card">
        <div className="max-w-5xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="legal-back-home">
            <Logo size={32} />
            <span className="font-display font-extrabold text-lg">AfriMeet</span>
          </Link>
          <Link
            to="/"
            className="text-sm text-terracotta font-semibold hover:underline inline-flex items-center gap-1.5"
          >
            <ArrowLeft className="h-4 w-4" /> Retour à l&apos;accueil
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-16" data-testid={testId}>
        <div className="text-xs uppercase tracking-widest text-terracotta font-semibold mb-3">Documents légaux</div>
        <h1 className="font-display font-extrabold text-4xl md:text-5xl mb-4 leading-tight">{title}</h1>
        {subtitle && <p className="text-af-secondary mb-10 text-base leading-relaxed">{subtitle}</p>}
        <article className="legal-content space-y-4 text-af-secondary leading-relaxed text-[15px]">
          {children}
        </article>
        <p className="mt-16 pt-8 border-t border-af text-xs text-af-muted">
          Pour toute question, écrivez-nous via la page <Link to="/contact" className="text-terracotta hover:underline font-semibold">Contact</Link>.
        </p>
      </main>
      <Footer />
    </div>
  );
}
